import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Sources } from "../types/interfaces";

interface SortableHeaderProps {
    label: string;
    sortKey: keyof Sources;
    sortConfig: { key: keyof Sources; direction: "asc" | "desc" } | null;
    onSort: (key: keyof Sources) => void;
}

/**
 * A sortable column heading.
 *
 * The arrow is always rendered, dimmed until the column is the active one, so
 * it is clear which columns can be sorted before anyone clicks. aria-sort tells
 * screen readers the same thing, and the header is a real button so it can be
 * reached and triggered from the keyboard.
 */
export default function SortableHeader({ label, sortKey, sortConfig, onSort }: SortableHeaderProps) {
    const isActive = sortConfig?.key === sortKey;
    const direction = isActive ? sortConfig!.direction : undefined;

    return (
        <th aria-sort={isActive ? (direction === "asc" ? "ascending" : "descending") : "none"}>
            <button type="button" className="sort-button" onClick={() => onSort(sortKey)}>
                {label}
                <span className={isActive ? "sort-indicator sort-indicator-active" : "sort-indicator"}>
                    {direction === "desc" ? (
                        <KeyboardArrowDownIcon fontSize="small" />
                    ) : (
                        <KeyboardArrowUpIcon fontSize="small" />
                    )}
                </span>
            </button>
        </th>
    );
}
